import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { setRedirectAfterLogin, useAuth, type UserRole } from '@features/auth';
import { AuthErrorScreen } from './AuthErrorScreen';

interface ProtectedRouteProps {
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, user, error } = useAuth();
  const location = useLocation();

  // Não foi possível confirmar a sessão (ex.: 429 rate limit, 5xx, rede) e não
  // temos usuário em cache. O token pode continuar válido, então mostramos o
  // erro em tela com opção de tentar de novo — NÃO mandamos para o /login.
  if (!isAuthenticated && error) {
    return <AuthErrorScreen error={error} />;
  }

  if (!isAuthenticated) {
    setRedirectAfterLogin(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
